var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "sdr-box contact-box",
      staticStyle: { border: "3px solid #ffb400" },
    },
    [
      _c("h4", {
        staticStyle: { color: "#0082c8", "font-weight": "700" },
        domProps: {
          innerHTML: _vm._s(_vm.importantinfosheader[_vm.getCurrentLocale]),
        },
      }),
      _vm._v(" "),
      _c("address", { staticClass: "contact-details" }, [
        _c("span", { staticClass: "contact-phone" }, [
          _c("i", { staticClass: "soap-icon-insurance" }),
          _c(
            "a",
            { attrs: { href: "/infos-serviceonboard/#/serviceonboard" } },
            [_vm._v(" " + _vm._s(_vm.importantinfostext[_vm.getCurrentLocale]))]
          ),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }